import logo from "../assets/images/billbitcoins-logo.png";
import BtcLogo from "../assets/images/currency/BTC.svg";
import EthLogo from "../assets/images/currency/ETH.svg";
import LtcLogo from "../assets/images/currency/LTC.svg";
import BchLogo from "../assets/images/currency/BCH.svg";
import ZecLogo from "../assets/images/currency/ZEC.svg";
import DogeLogo from "../assets/images/currency/DOGE.svg";
import HcxLogo from "../assets/images/currency/HCX.svg";
import XrpLogo from "../assets/images/currency/XRP.svg";
import UsdtLogo from "../assets/images/currency/USDT.svg";
import UsdcLogo from "../assets/images/currency/USDC.svg";
const DEVELOPMENTOBJ = {
  url: "http://localhost:3000",
  api: "https://service.hashcashconsultants.com/billbitcoins-v2",
  baseurl: "/",
  filePath: "https://billbitcoins.com/app/v2/merchant/images",
};
const PRODUCTIONOBJ = {
  url: "https://billbitcoins.com/app/v2/merchant/ ",
  api: "https://service.hashcashconsultants.com/billbitcoins-v2",
  filePath: "https://billbitcoins.com/app/v2/merchant/images",
};

const TEST_API = "https://service.hashcashconsultants.com/billbitcoins-v3";

export const mode = "prod"; //dev : development; prod : production

const checkTestMode = () => {
  if (typeof window === "undefined") return false;

  const path = window.location.pathname;
  // These paths should always use Live Mode API
  const liveOnlyPatterns = [
    /^\/$/,
    /\/login\/?$/,
    /\/signup\/?/,
    /\/otp\/?$/,
    /\/forgot-password\/?$/,
    /\/reset-password\/?/,
    /\/autologin\/?/,
  ];

  if (liveOnlyPatterns.some((pattern) => pattern.test(path))) {
    return false;
  }

  const url = window.location.href;
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const data = params.get("data");

  if (url.includes("TEST")) return true;

  if (data) {
    try {
      const decoded = JSON.parse(atob(data.replace(/ /g, "+")));
      const pId = decoded.paymentId || decoded.payment_id;
      if (pId && String(pId).includes("TEST")) return true;
    } catch (e) {}
  }

  return localStorage.getItem("bill_bitcoins_is_test_mode") === "true";
};

export const isTestMode = checkTestMode();

if (mode == "dev") {
  var url = DEVELOPMENTOBJ.url;
  var api = isTestMode ? TEST_API : DEVELOPMENTOBJ.api;
  var baseurl = DEVELOPMENTOBJ.baseurl;
  var filePath = DEVELOPMENTOBJ.filePath;
} else {
  var url = PRODUCTIONOBJ.url;
  var api = isTestMode ? TEST_API : PRODUCTIONOBJ.api;
  var baseurl = PRODUCTIONOBJ.baseurl;
  var filePath = PRODUCTIONOBJ.filePath;
}

export const ADDR = url;
export const WEBSERVICE = api;
export const LIVE_WEBSERVICE = mode === "dev" ? DEVELOPMENTOBJ.api : PRODUCTIONOBJ.api;
export const ACCOUNTS_WEBSERVICE = "https://accounts.paybito.com";
export const BASEURL = baseurl;
export const FILEPATH = filePath;

export const SITENAME = "Bill Bitcoins";
export const SITENAMEALIAS = "bill_bitcoins";
export const LOGO = logo;
export const PAYMENTURLFORHOSTEDCATALOG =
  window.location.origin +
  "/merchant/init-payment-hosted-catalog.html";

export const PAYPAL_CLIENT_ID = "AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqIgrkwP3tbKFAfCjli11l1LkWf0NpvsB";

export const CAPTCHASITEKEY = "pbk_live_fb3223b4540ecc8f45c1fae4c582b8b0";
export const PAYBITOCAPTCHASITEKEY = "6LeJ1IoqAAAAAHCRhEuSpIsMLSPf5wRyX_jTTeYD";
export const DEMOBROKER = "https://portal.paybito.com";
// export const DEMOBROKER = 'http://localhost:3000';

export const COUNTRYLIST = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas (the)",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia (Plurinational State of)",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory (the)",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands (the)",
  "Central African Republic (the)",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands (the)",
  "Colombia",
  "Comoros (the)",
  "Congo (the Democratic Republic of the)",
  "Congo (the)",
  "Cook Islands (the)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czechia",
  "Côte d'Ivoire",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic (the)",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Falkland Islands (the) [Malvinas]",
  "Faroe Islands (the)",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories (the)",
  "Gabon",
  "Gambia (the)",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See (the)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran (Islamic Republic of)",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea (the Democratic People's Republic of)",
  "Korea (the Republic of)",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic (the)",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands (the)",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia (Federated States of)",
  "Moldova (the Republic of)",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands (the)",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger (the)",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands (the)",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine, State of",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines (the)",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Republic of North Macedonia",
  "Romania",
  "Russian Federation (the)",
  "Rwanda",
  "Réunion",
  "Saint Barthélemy",
  "Saint Helena, Ascension and Tristan da Cunha",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin (French part)",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten (Dutch part)",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan (the)",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands (the)",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates (the)",
  "United Kingdom of Great Britain and Northern Ireland (the)",
  "United States Minor Outlying Islands (the)",
  "United States of America (the)",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela (Bolivarian Republic of)",
  "Viet Nam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "Åland Islands",
];

export const ASSETS = [
  {
    assetId: 2,
    assetCode: "BTC",
    assetImage: BtcLogo,
    assetName: "Bitcoin",
    network: ["NATIVE"],
  },
  {
    assetId: 7,
    assetCode: "LTC",
    assetImage: LtcLogo,
    assetName: "Litecoin",
    network: ["NATIVE"],
  },
  {
    assetId: 3,
    assetCode: "ETH",
    assetImage: EthLogo,
    assetName: "Ethereum",
    network: ["NATIVE"],
  },
  {
    assetId: 4,
    assetCode: "BCH",
    assetImage: BchLogo,
    assetName: "Bitcoin Cash",
    network: ["NATIVE"],
  },
  /* {
	assetId: 13,
	assetCode: 'ZEC',
	assetImage: ZecLogo,
	assetName: 'Zcash',
	network: ['NATIVE']
}, */
  {
    assetId: 124,
    assetCode: "DOGE",
    assetImage: DogeLogo,
    assetName: "Dogecoin",
    network: ["NATIVE"],
  },
  {
    assetId: 8,
    assetCode: "HCX",
    assetImage: HcxLogo,
    assetName: "Hashcash Coin",
    network: ["NATIVE"],
  },
  {
    assetId: 14,
    assetCode: "XRP",
    assetImage: XrpLogo,
    assetName: "Ripple",
    network: ["NATIVE"],
  },
  {
    assetId: 148,
    assetCode: "USDC",
    assetImage: UsdcLogo,
    assetName: "USDC",
    network: ["ERC"],
  },
  {
    assetId: 16,
    assetCode: "USDT",
    assetImage: UsdtLogo,
    assetName: "Tether",
    network: ["TRC", "ERC"],
  },
];

export const RECURRINGPAYMENT = WEBSERVICE + "/recurring_payment";

export const REFUND = WEBSERVICE + "/refund";

export const CURRENCIES = [
  { code: "USD", name: "US Dollar", country: "United States", flag: "🇺🇸" },
  { code: "EUR", name: "Euro", country: "European Union", flag: "🇪🇺" },
  { code: "GBP", name: "British Pound", country: "United Kingdom", flag: "🇬🇧" },
  /* { code: "INR", name: "Indian Rupee", country: "India", flag: "🇮🇳" }, */
  { code: "AUD", name: "Australian Dollar", country: "Australia", flag: "🇦🇺" },
  { code: "CAD", name: "Canadian Dollar", country: "Canada", flag: "🇨🇦" },
  { code: "SGD", name: "Singapore Dollar", country: "Singapore", flag: "🇸🇬" },
  /* { code: "AED", name: "UAE Dirham", country: "UAE", flag: "🇦🇪" }, */
  { code: "JPY", name: "Japanese Yen", country: "Japan", flag: "🇯🇵" },
  { code: "CHF", name: "Swiss Franc", country: "Switzerland", flag: "🇨🇭" },
  { code: "HKD", name: "Hong Kong Dollar", country: "Hong Kong", flag: "🇭🇰" },
  { code: "MYR", name: "Malaysian Ringgit", country: "Malaysia", flag: "🇲🇾" },
  { code: "BRL", name: "Brazilian Real", country: "Brazil", flag: "🇧🇷" },
  /* { code: "ZAR", name: "South African Rand", country: "South Africa", flag: "🇿🇦" }, */
  {
    code: "NZD",
    name: "New Zealand Dollar",
    country: "New Zealand",
    flag: "🇳🇿",
  },
];
